import React from 'react';

import classNames from 'classnames';

/**
 * Filter chips for the picker (IB-641): a Year chip per distinct project year
 * (derived from project start dates) plus a "Show archived" toggle. Type / Phase
 * / Region / Status are deferred (no backing Event data) and intentionally absent.
 */
export default function PickerFilters({ years, activeYear, onSelectYear, showArchived, onToggleArchived, onClear }) {
    const hasFilters = activeYear !== null || showArchived;

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
            {years.map((year) => (
                <Chip key={year} active={activeYear === year} onClick={() => onSelectYear(activeYear === year ? null : year)}>
                    {year}
                </Chip>
            ))}

            <Chip active={showArchived} onClick={onToggleArchived}>
                {$t('Show archived')}
            </Chip>

            {hasFilters && (
                <button type="button" onClick={onClear} className="tw-text-xs tw-text-blue tw-font-medium tw-ms-1">
                    {$t('Clear filters')}
                </button>
            )}
        </div>
    );
}

function Chip({ active, onClick, children }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={classNames('tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-border', {
                'tw-bg-blue-10 tw-text-blue tw-border-blue-25': active,
                'tw-bg-white tw-text-charcoal-75 tw-border-grey': !active,
            })}
        >
            {children}
        </button>
    );
}
